import { differenceInCalendarDays } from 'date-fns';
import { useCurrentPlanInfo } from '@aibees/shared/features/price-and-plan/hooks/use-current-plan-info';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';

export function useAccountPopoverCreditPlanDetail() {
  const { data } = useCurrentSubscriptionApi();
  const { rollOver } = useCurrentPlanInfo();

  const renewalDate = data?.current?.currentPeriodEnd;
  const daysUntilRenewal = renewalDate
    ? differenceInCalendarDays(new Date(renewalDate), new Date())
    : undefined;
  const renewsWithinAWeek =
    daysUntilRenewal !== undefined &&
    daysUntilRenewal >= 0 &&
    daysUntilRenewal <= 7;

  // Nudge the user to spend rollover credits before they expire at renewal
  const showRolloverHint = rollOver > 0 && renewsWithinAWeek;

  return { showRolloverHint, rollOver, renewalDate };
}
